import { render, staticRenderFns } from "./additives.vue?vue&type=template&id=5b8f9629&"
import script from "./additives.vue?vue&type=script&lang=js&"
export * from "./additives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports